import "./App.css";
import { Link } from "react-router-dom";
import img from './imgs/intro.webp'

function CallToAction(prop) {
 const styles = {
  intro: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftIntro: {
    width: '40%',
  },
  leftIntroHeading: {
    fontFamily: 'Roboto Black',
  },
  leftIntroParagraph: {
    marginTop: 15,
    fontFamily: 'Roboto',
    fontSize: 18,
  },
  leftIntroButton: {
    fontFamily: 'Roboto',
    fontSize: 18,
    padding: 10,
    borderRadius: 5,
    marginTop: '15%',
  },
};
 return (
  <>
  <article style={styles.intro}>
      <div style={styles.leftIntro}>
        <h1 style={styles.leftIntroHeading}>Little Lemon</h1>
        <h5>Chicago</h5>
        <p style={styles.leftIntroParagraph}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae
          laudantium, exercitationem consequatur blanditiis mollitia delectus
          incidunt minima eaque, cum necessitatibus autem quam magni, soluta ipsam
          nam voluptas amet. Ut, aspernatur?
        </p>
        <Link to="/reservations">
          <button style={styles.leftIntroButton}>Reserve a Table</button>
        </Link>
      </div>
      <div className="right__intro">
        <img src={img} alt="master-chef smiling face" />
      </div>      
    </article>
  </>
 );
}

export default CallToAction;
